import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { redirectMappings } from 'src/app/app.component';
import { ThemeService } from 'src/app/core/services/theme.service';
import { Observable, Subject, takeUntil } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-redirect',
  templateUrl: './redirect.component.html',
  styleUrls: ['./redirect.component.scss'],
  standalone: false,
})
export class RedirectComponent implements OnInit, OnDestroy {
  countdown: number = 5;

  targetUrl: string = '';

  progress: number = 0;

  private intervalId: any;

  private stop$ = new Subject<void>();

  public logoUrl$: Observable<string>;

  public hasCustomLogoComponent$: Observable<boolean>;

  public logoTitle$: Observable<string>;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private themeService: ThemeService,
  ) {
    this.logoUrl$ = this.themeService.currentTheme$.pipe(
      map(theme => theme.assets.logo),
      takeUntil(this.stop$),
    );
    this.hasCustomLogoComponent$ = this.themeService.currentTheme$.pipe(
      map(theme => !!theme.assets.logoComponent),
      takeUntil(this.stop$),
    );
    this.logoTitle$ = this.themeService.currentTheme$.pipe(
      map(theme => theme.assets.logoTitle || ''),
      takeUntil(this.stop$),
    );
  }

  ngOnInit() {
    const hostname = window.location.hostname;
    const port = window.location.port;
    const hostWithPort = port ? `${hostname}:${port}` : hostname;

    this.targetUrl = redirectMappings[hostWithPort] || redirectMappings[hostname];

    this.route.queryParams.subscribe(params => {
      if (params.url) {
        this.targetUrl = params.url;
      }
    });

    if (!this.targetUrl) {
      this.router.navigate(['/']);
      return;
    }

    this.startCountdown();
  }

  startCountdown() {
    const totalTime = this.countdown * 1000;
    const updateInterval = 50;
    let elapsed = 0;

    this.intervalId = setInterval(() => {
      elapsed += updateInterval;
      this.progress = (elapsed / totalTime) * 100;

      const remainingSeconds = Math.ceil((totalTime - elapsed) / 1000);
      this.countdown = remainingSeconds;

      if (elapsed >= totalTime) {
        clearInterval(this.intervalId);
        this.redirect();
      }
    }, updateInterval);
  }

  redirect() {
    window.location.href = this.targetUrl;
  }

  ngOnDestroy() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
    this.stop$.next();
    this.stop$.complete();
  }
}
